
    import '/mnt/src/components/Dialog/index.md?watch=parent';
    export const demoIndex = {
  ids: ["dialog-demo-imperative"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Dialog/index.md?type=demo')
};